module.exports = __webpack_public_path__ + "static/orion-e0ba304fb92643d9f0c13dd863582df1.svg";